import axios from "axios";
import React, { useState } from "react";
import apiConfig from "../../../apiConfig";

const SalesReport = () => {
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [startDateCate, setStartDateCate] = useState("");
    const [endDateCate, setEndDateCate] = useState("");
    const [loading, setLoading] = useState(false);

    const handleDownload = async () => {
        const data = {
            startDate: startDate,
            endDate: endDate,
        };
        setLoading(true);

        try {
            const res = await axios.post(
                `${apiConfig.baseUrl}/${apiConfig.SalesReport}`,
                data,
                {
                    responseType: "blob",
                }
            );

            const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `sales-report-${startDate}_to_${endDate}.csv`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setEndDate("");
            setStartDate("");
        } catch (error) {
            console.error("❌ Error downloading report:", error);
            alert("Failed to download the report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadCate = async () => {
        const data = {
            startDate: startDate,
            endDate: endDate,
        };
        setLoading(true);
        try {
            const res = await axios.post(
                `${apiConfig.baseUrl}/${apiConfig.CategortSalesReport}`,
                data,
                {
                    responseType: "blob",
                }
            );

            const blob = new Blob([res.data], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `sales-report-${startDate}_to_${endDate}.csv`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setEndDateCate("");
            setStartDateCate("");
        } catch (error) {
            console.error("❌ Error downloading report:", error);
            alert("Failed to download the report. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div
                style={{
                    maxWidth: "600px",
                    margin: "40px auto",
                    padding: "30px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    fontFamily: "Segoe UI, sans-serif",
                }}
            >
                <h2
                    style={{
                        textAlign: "center",
                        marginBottom: "30px",
                        color: "#333",
                    }}
                >
                    Product Sales Report
                </h2>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleDownload();
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                        }}
                    >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                                Start Date
                            </label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                required
                                style={{
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                                End Date
                            </label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                                style={{
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                padding: "12px",
                                backgroundColor: "#4CAF50",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                cursor: loading ? "not-allowed" : "pointer",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            {loading ? "Downloading..." : "⬇️ Download Report"}
                        </button>
                    </div>
                </form>
            </div>
            <div
                style={{
                    maxWidth: "600px",
                    margin: "40px auto",
                    padding: "30px",
                    backgroundColor: "#fff",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    borderRadius: "8px",
                    fontFamily: "Segoe UI, sans-serif",
                }}
            >
                <h2
                    style={{
                        textAlign: "center",
                        marginBottom: "30px",
                        color: "#333",
                    }}
                >
                    Category Sales Report
                </h2>

                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        handleDownloadCate();
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "20px",
                        }}
                    >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                                Start Date
                            </label>
                            <input
                                type="date"
                                value={startDateCate}
                                onChange={(e) => setStartDateCate(e.target.value)}
                                required
                                style={{
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginBottom: "5px", fontWeight: "bold" }}>
                                End Date
                            </label>
                            <input
                                type="date"
                                value={endDateCate}
                                onChange={(e) => setEndDateCate(e.target.value)}
                                required
                                style={{
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                padding: "12px",
                                backgroundColor: "#4CAF50",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                cursor: loading ? "not-allowed" : "pointer",
                                transition: "background-color 0.2s ease",
                            }}
                        >
                            {loading ? "Downloading..." : "⬇️ Download Report"}
                        </button>
                    </div>
                </form>
            </div>
            {/* {loading && <Loade />} */}
        </>
    );
};

export default SalesReport;
